import { pure, withState, mapProps, defaultProps, compose } from "recompose";
import styles from "./Collapsible.scss";

export const enhanceWithCollapsible = compose(
  withState("expanded", "setExpand", props => props.initiallyExpanded),
  mapProps(({ setExpand, ...rest }) => ({
    toggleExpand: () => setExpand(expanded => !expanded),
    setExpand,
    ...rest,
  })),
  defaultProps({
    childrenClassName: styles && styles.collapsibleChildren,
    expandedClassName: styles && styles.expanded,
  }),
  pure
);
